export default __webpack_public_path__ + "static/mewa-cleanroom-image-552fa3f0d72780a8372f95eb918d9d2b.jpg";